import Vue from 'vue'
import Router from 'vue-router'
// 登录页
import login from '@/components/login'  //登录
import cityBrain from '@/components/cityBrain'  //城市大脑
import main from "@/components/Main/main"// 主页面
import dataBoard from "@/components/Main/DataBoard/dataBoard"    //数据看板
import liveVideo from "@/components/Main/LiveVideo/liveVideo"     // 实时视频页面
import clusterIntercom from "@/components/Main/CombinedAction/clusterIntercom"   //集群对讲
import instructionsIssued from "@/components/Main/CombinedAction/instructionsIssued"   //指令下达
import electronicFence from "@/components/Main/CombinedAction/electronicFence"   //电子围栏
import fileView from "@/components/Main/EvidenceCenter/fileView" //文件查看
import trackPlayback from "@/components/Main/EvidenceCenter/trackPlayback"    //轨迹回放
import warningRecord from "@/components/Main/EvidenceCenter/warningRecord"    //预警记录
import statistics from "@/components/Main/EvidenceCenter/statistics"    //统计分析
import tag from "@/components/Main/EvidenceCenter/tag"    //文件标签
import faceDatabase from "@/components/Main/IntelligentAI/faceDatabase"    //人脸库
import numberplateDatabase from "@/components/Main/IntelligentAI/numberplateDatabase"    //车牌库
import deviceManagement from "@/components/Main/SystemManagement/deviceManagement" //设备管理
import personnelManagement from "@/components/Main/SystemManagement/personnelManagement" //人员管理
import rightsManagement from "@/components/Main/SystemManagement/rightsManagement" //权限管理
import unitsManagement from "@/components/Main/SystemManagement/unitsManagement" //单位管理
import userManagement from "@/components/Main/SystemManagement/userManagement" //用户管理
import systemLog from "@/components/Main/Log/systemLog"    //系统日志
import centralServerConfig from "@/components/Main/ServerManager/centralServerConfig"    //中心服务器配置
import collectionConfig from "@/components/Main/ServerManager/collectionConfig"    //采集站配置
import NotFound from '@/components/NotFound'  //404页面

Vue.use(Router)


export default new Router({
  // mode:'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'cityBrain',
    //   component: cityBrain
    // }, //城市大脑
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: login
    // }, //登录界面
    {
      path: '/',
      redirect: '/login',     //默认定向到实时登录页面
    }, //城市大脑
    {
      path: '/login',
      name: 'Login',
      component: login
    }, //登录界面
    {
      path: '/dataBoard',
      name: 'dataBoard',
      component: dataBoard
    }, //数据看板
    {
      path: '/main',
      name: 'Main',
      component: main,
      // redirect: '/dataBoard',     //登录后默认定向到实时调度页面
      children: [     
        {
          path: '/liveVideo',
          name: 'LiveVideo',
          component: liveVideo
        },  //实时调度
        {
          path: '/combinedAction',
          name: 'combinedAction',
          // redirect: "/combinedAction/instructionsIssued" //重定向到指令下达
        },  //协同作战
        {
          path: "/combinedAction/clusterIntercom",
          name: "clusterIntercom",
          component: clusterIntercom
        },//集群对讲
        {
          path: "/combinedAction/instructionsIssued",
          name: "instructionsIssued",
          component: instructionsIssued
        },//指令下达
        {
          path: '/combinedAction/electronicFence',
          name: 'electronicFence',
          component: electronicFence
        },  //电子围栏
        {
          path: '/evidenceCenter',
          name: 'evidenceCenter',
          // redirect: "/evidenceCenter/fileView" //重定向到文件查看
        },  //证据中心 
        {
          path: '/evidenceCenter/fileView',
          name: 'fileView',
          component: fileView
        },  //文件查看

        {
          path: '/evidenceCenter/trackPlayback',
          name: 'trackPlayback',
          component: trackPlayback
        },  //轨迹回放
        {
          path: '/evidenceCenter/warningRecord',
          name: 'warningRecord',
          component: warningRecord
        },  //预警记录
        {
          path: '/evidenceCenter/statistics',
          name: 'statistics',
          component: statistics
        },  //统计分析
        {
          path: '/evidenceCenter/tag',
          name: 'tag',
          component: tag
        },  //文件标签
        {
          path: '/intelligentAI',
          name: 'intelligentAI',
          // redirect: "/intelligentAI/faceDatabase" //重定向到人脸库
        },  //智能AI
        {
          path: '/intelligentAI/faceDatabase',
          name: 'faceDatabase',
          component: faceDatabase
        },  //人脸库
        {
          path: '/intelligentAI/numberplateDatabase',
          name: 'numberplateDatabase',
          component: numberplateDatabase
        },  //人脸库
        {
          path: '/systemManagement',
          name: 'systemManagement',
          // redirect: "/systemManagement/unitsManagement" //重定向到设备管理
        },  //系统管理
        {
          path: '/systemManagement/unitsManagement',
          name: 'unitsManagement',
          component: unitsManagement
        },  //单位管理
        {
          path: '/systemManagement/deviceManagement',
          name: 'deviceManagement',
          component: deviceManagement
        },  //设备管理
        {
          path: '/systemManagement/personnelManagement',
          name: 'personnelManagement',
          component: personnelManagement
        },  //人员管理
        {
          path: '/systemManagement/rightsManagement',
          name: 'rightsManagement',
          component: rightsManagement
        },  //权限管理

        {
          path: '/systemManagement/userManagement',
          name: 'userManagement',
          component: userManagement
        },  //用户管理
        {
          path: '/log',
          name: 'log',
          redirect: "/log/systemLog" //重定向到系统日志
        },  //日志管理
        {
          path: '/log/systemLog',
          name: 'systemLog',
          component: systemLog
        },  //系统日志
        {

          path: '/serverManager',
          name: 'serverManager',
          // redirect: "/serverManager/centralServerConfig" //重定向到媒体服务器配置
        },  //服务器管理
        {
          path: '/serverManager/centralServerConfig',
          name: 'centralServerConfig',
          component: centralServerConfig
        },  //中心服务器配置
        {
          path: '/serverManager/collection',
          name: 'collectionConfig',
          component: collectionConfig
        },  //采集站配置
        {
          path: '/404', component: NotFound, name: 404
        }, //404页面

      ]
    },

  ]
})






// WEBPACK FOOTER //
// ./src/router/index.js